"use client";

import { useRef, useEffect, useState } from "react";
import Link from "next/link";
import { useParallax } from "@/hooks/useParallax";
import styles from "./not-found.module.scss";

const NotFound = () => {
	const stampRef = useRef<HTMLAnchorElement>(null);
	const [isMounted, setIsMounted] = useState(false);

	// Ensure component is mounted before applying parallax
	useEffect(() => {
		setIsMounted(true);
	}, []);

	// Apply parallax with rotation to 404 stamp
	useParallax(stampRef, {
		speed: 0.8,
		direction: 'down',
		distance: 60,
		rotation: { start: -5, end: 5 },
		scrub: 1.5,
		disabled: !isMounted,
	});

	return (
		<div className={styles.notFoundPage}>
			<Link ref={stampRef} href="/" className={styles.stamp}>
				<img src="/images/stamp-404.svg" alt="Error 404 - Page Not Found" />
			</Link>
		</div>
	);
};

export default NotFound;
